import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useUnitDetailsStore = create<any>(
  persist(
    (set) => ({
      unitId: null,
      status: null,
      setValues: (id: string, status: string) => set(() => ({ unitId: id, status }))
    }),
    {
      name: 'unit-details'
    }
  )
)
